export default {
  namespaced: true,
  state: {
    loading: true,
    apiIndex: 0
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_API_INDEX(state, apiIndex) {
      state.apiIndex = apiIndex
    }
  }
}